var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',_vm._b({attrs:{"value":_vm.value,"options":_vm.options,"default-expand-level":_vm.expandLevel},on:{"input":function($event){return _vm.$emit('input', $event)}}},'treeselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }